import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "login-wrap"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "holder holder-fluid"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "login"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Почта подтверждена"), /*#__PURE__*/_createElementVNode("div", {
  class: "reg-text"
}, [/*#__PURE__*/_createElementVNode("p", null, "После модерации аккаунта, мы отправим Вам на почту письмо с уведомлением активации")])])], -1);

const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 1,
  class: "login-wrap"
};
const _hoisted_5 = {
  class: "holder holder-fluid"
};
const _hoisted_6 = {
  class: "login"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Ошибка", -1);

const _hoisted_8 = {
  class: "reg-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.error === false ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3)) : $data.error ? (_openBlock(), _createElementBlock("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString($data.error), 1)])])])])) : _createCommentVNode("", true);
}